// ABOUTME: Notice plate — a block-level status message (paid until, past due, trial, error)
// ABOUTME: Same tones as CBadge: a badge states the status, a plate explains it

import type { FC, ReactNode } from "react"
import { cn } from "@shared/lib/utils"
import { TONE_CLASS, type CTone } from "./tone"

interface CInfoBlockProps {
  children: ReactNode
  /** Status tone — shared with CBadge (docs/DESIGN_SYSTEM.md §2). */
  tone?: CTone
  className?: string
  /** Optional title displayed above the content */
  title?: string
  /** Optional leading icon; sized by the caller. */
  icon?: ReactNode
}

export const CInfoBlock: FC<CInfoBlockProps> = ({ children, tone = "neutral", className, title, icon }) => {
  return (
    <div
      className={cn(
        "flex items-start gap-2.5 rounded-lg border px-3.5 py-3 text-sm leading-snug",
        TONE_CLASS[tone],
        className,
      )}
    >
      {icon && <span className="mt-px shrink-0 leading-none">{icon}</span>}
      <div className="min-w-0 flex-1">
        {title && <p className="mb-1 font-semibold">{title}</p>}
        {children}
      </div>
    </div>
  )
}
